const apiURL   = "https://parcel-intelligence.com/cs/api_ex.php";
const apiKEY   = "06adb90fce2000cbc89ec59b89a0b3161d020af2";

const formatMoney = (quantity)=>{
  let currency = '$';
  if( Number.isInteger(quantity) ){
    return `${currency}${quantity}.00`
  } else {
    return `${currency}${quantity.toString()}`
  }
}

// function addModal(element){
//   console.log(element);
// 	let modalId = element[0].id;
// 	let modalContent = element.find(".modal-content").html();
// 	$("body").prepend(`
// 		<div class="modal-wrap" id="modal-${modalId}">
// 			<div class="modal-container">
// 				<div class="close-modal">x</div>
// 					${modalContent}
// 			</div>
// 			<div class="backdrop"></div>
// 		</div>
// 	`);
// 	let popupModal = $('#modal-'+ modalId +'');
// 	element.click(function(event){
// 		event.preventDefault();
// 		popupModal.addClass("show-modal");
// 		popupModal.find(".modal-container").fadeIn();
// 	});
// 	popupModal.find(".close-modal").click(function(event){
// 		event.preventDefault();
// 		popupModal.removeClass("show-modal");
// 		popupModal.find(".modal-container").hide();

// 	});
// }

// function createRatesList(rates, placeName){
function createRatesList(rates, zipCode){
  let resultsContainer    = $("#shipping_result");
  let ratesHtmlList = "";
  let priceHolder = document.querySelector('.hc-dropdown__label p');

  for (var i = 0; i < rates.length; i++) {
    // CHANGE: formatedPrice ab har rate item ke liye fresh compute hota hai
    // (pehle loop ke bahar ek hi baar declare tha, stale value leak ho sakti thi)
    let formatedPrice = " - <span>FREE</span>";
    let price = parseInt(rates[i].total_price);

    if(price > 0){
      formatedPrice = " - " + formatMoney(rates[i].total_price / 100);
    }

    // CHANGE: case-insensitive check + indexOf !== -1 (pehle 'Quote' capital-case
    // tha jo "quoted" se match nahi hota, aur >=1 threshold "Quote" ko start
    // (index 0) pe hone par bhi miss kar deta tha)
    if (rates[i].service_name.toLowerCase().indexOf('quote') !== -1) {
      formatedPrice = "";
    }

    ratesHtmlList += `
    <div class="shipping__item">
    ${rates[i].service_name}
    ${formatedPrice}
    </div>
    `;

    console.log("++++++++++++++++++++++++", formatedPrice);

    if (priceHolder) {
      if(formatedPrice !== '') {
        if(rates[0].total_price > 0) {
          let price = `$${rates[0].total_price / 100}.00`;
          let vscompAttr = document.querySelector('.vscomp-value').getAttribute('data-tooltip');
          let vscompArray1 = vscompAttr.split('(');
          let vscompArray2 = vscompArray1[0].split('-');
          priceHolder.innerHTML = `Estimated delivery rate <span> ${price} to ${vscompArray2[1]} ${vscompArray2[0]}</span>`;
        } else {
          let vscompAttr = document.querySelector('.vscomp-value').getAttribute('data-tooltip');
          let vscompArray1 = vscompAttr.split('(');
          let vscompArray2 = vscompArray1[0].split('-');
          priceHolder.innerHTML = `Estimated delivery rate FREE to ${vscompArray2[1]} ${vscompArray2[0]}`;
        }
      } else {
        priceHolder.innerHTML = 'Click here to estimate Shipping';
      }
    }
  }

  resultsContainer.find(".shipping_data").html(ratesHtmlList);
  if(!resultsContainer.hasClass("active")){
    resultsContainer.slideToggle("fast").addClass("active");
  }
}

const syncAJAX = (options) => {
  return new Promise((resolve,reject)=>{
    $.ajax(options)
    .done(function(response, __, xhr) {
      resolve({
        'xhr':xhr,
        'body':response
      })
    })
    .fail(function(xhr) {
      reject({
        'xhr':xhr});
    });
  });
}

const calculateZip = (zipCode_handler, quantity_handler, zip_code) => {
  let zipCode = zip_code == undefined ? $(`${zipCode_handler}`).val() : zip_code;
  let variantId = parseInt($(`${zipCode_handler}`).attr("data-variant-id"));
  let quantity = $(`${quantity_handler}`).val();
  let product = JSON.parse($("#product__shipping-product-json").html());
  let customerTag = $(`${zipCode_handler}`).attr("data-customer-tag");
  console.log({
    'zipCode':zipCode,
    '?zipCode': zip_code == undefined,
    'variantId':variantId,
    'quantity':quantity,
    'product':product,
    'customerTag':customerTag
  });
  
  let formData = {
    "origin":{
      "country":"AU",
      "postal_code":"2040",
      "province":"NSW",
      "city":"Sydney",
      "address1":"483 Balmain Road",
      "company_name":"SLH"
    },
    "destination":{
      "postal_code": zipCode,
    },
    "items":[
      {
        "name": product.title,
        "quantity": quantity,
        "product_id": product.id,
        "variant_id": variantId
      }
    ],
    "CUSTOMER_TYPE": customerTag,
    "API_KEY": apiKEY
  };
  let settings = {
    url: apiURL,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "HTTP_X_STORE_NAME": "slh-au.myshopify.com",
      "HTTP_X_STORE_TOKEN": apiKEY
    },
    data: JSON.stringify(formData),
  };
  let ajaxResult;
  syncAJAX(settings).then((data)=>{
    ajaxResult = data;
    if( data.xhr.status == 200 ){
      createRatesList(data.body.rates, zipCode);
    }
    $("#shipping__calculate").removeClass("loading").prop("disabled", false);
  }).catch((err)=>{
    // HANDLE ERROR
  })
}

$(document).ready(function () {
  // CHANGE: Calculate button stays disabled until a postcode is actually
  // selected. Runs once on page load, and again every time #zip-select's
  // value changes (VirtualSelect dispatches a 'change' event on it).
  function updateCalculateButtonState() {
    const currentZip = $("#zip-select").val();
    $("#shipping__calculate").prop("disabled", !currentZip);
  }

  updateCalculateButtonState(); // initial state on page load

  $(document).off('change.shippingCalcBtnState').on(
    'change.shippingCalcBtnState',
    '#zip-select',
    updateCalculateButtonState
  );

  $("#shipping__calculate").click(function (event) {
    event.preventDefault();

    // CHANGE: extra guard — bail out if somehow clicked with no postcode
    // selected (disabled attribute should already prevent this, but this
    // keeps the click handler safe on its own regardless)
    if (!$("#zip-select").val()) return;

    $(this).addClass("loading").prop("disabled", true);
    calculateZip("#zip-select", ".o-quantity-selector__select-field input[type='number']");
  });

  // CHANGE: quantity +/- ya direct type karne pe bhi shipping auto re-calculate
  // hogi — lekin SIRF tab jab postcode already select ho chuka ho. Debounce
  // isliye taaki rapid +/- clicks pe baar-baar AJAX na chale (400ms wait
  // karke sirf aakhri value pe calculate karega).
  const safeDebounce = typeof debounce === 'function' ? debounce : function (fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait || 100);
    };
  };

  const debouncedQuantityRecalc = safeDebounce(function () {
    const currentZip = $("#zip-select").val();
    if (!currentZip) return; // koi postcode select nahi hua abhi tak — kuch karne ki zaroorat nahi

    $("#shipping__calculate").addClass("loading").prop("disabled", true);
    calculateZip("#zip-select", ".o-quantity-selector__select-field input[type='number']", currentZip);
  }, 200);

  // Namespaced + delegated — DOM re-render hone pe bhi kaam karega, aur
  // agar script kabhi double-load ho to duplicate binding nahi hogi
  $(document).off('change.shippingQtyRecalc').on(
    'change.shippingQtyRecalc',
    ".o-quantity-selector__select-field input[type='number']",
    debouncedQuantityRecalc
  );
});